import { render, staticRenderFns } from "./PotreeViewer.vue?vue&type=template&id=2cf81110&scoped=true"
import script from "./PotreeViewer.vue?vue&type=script&lang=js"
export * from "./PotreeViewer.vue?vue&type=script&lang=js"
import style0 from "./PotreeViewer.vue?vue&type=style&index=0&id=2cf81110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf81110",
  null
  
)

export default component.exports